export class LookupGeneric<TValue> {
  id: TValue;
}

export class Lookup extends LookupGeneric<number> {
  nameAr: string;
  nameEn: string;
  nameUr?: string;
  code?: string;
  parentId?: number;
}

export class YesNoLkp extends Lookup {
  value: boolean;
}
